import { put, takeLatest, takeEvery, select } from 'redux-saga/effects'
import * as Eff from 'redux-saga/effects' // tslint:disable-line:no-duplicate-imports
import toastr from 'toastr'
import showConfetti from '@Utils/ShowConfettiAnimation'

// TODO: !!
import 'toastr/build/toastr.css'

import Logger from '@Utils/Logger'

import {
  IAction,
  ISuccessResponse
} from '@Root/types'

import {
  createProjectSuccess,
  createProjectFailure,
  fetchProjectsSuccess,
  fetchProjectsFailure,
  updateProjectsSuccess,
  updateProjectsFailure,
  deleteProjectsSuccess,
  deleteProjectsFailure,
  updateProjectTitleSuccess,
  updateProjectTitleFailure,
  createClipsSuccess,
  createClipsFailure,
  fetchProjects,
  startBulkExportationSuccess,
  startBulkExportationFailure,
} from './actions'

import {
  closeSetupProjectPopup,
  closeDashboardPopups,
} from '@SiteModules/Popup/actions'

import {
  getUserInfo,
} from '@SiteModules/User/actions'

import {
  completeProjectSubmission,
  failProjectSubmission,
} from '@SiteModules/ProjectVersionSettings/actions'

import {
  ProjectActionTypes,
  ICreateProjectSuccessResponseBody,
  ICreateProjectPayload,
  IFetchProjectsPayload,
  IFetchProjectsSuccessResponseBody,
  IUpdateProjectsPayload,
  IUpdateProjectsSuccessResponseBody,
  IDeleteProjectsPayload,
  IUpdateProjectTitlePayload,
  ICreateClipsPayload,
  IStartBulkExportationPayload,
} from './types'

import * as API from './api'

const call: any = Eff.call

function* fetchProjectsSaga(action: IAction<IFetchProjectsPayload>) {
  try {
    const response: ISuccessResponse<IFetchProjectsSuccessResponseBody> = yield call(API.fetchProjects, action.payload)

    yield put(fetchProjectsSuccess(response.data))
  } catch (e) {
    Logger.error(e, 'Projects could not be loaded')
    yield put(fetchProjectsFailure())
  }
}

function* updateProjectsSaga(action: IAction<IUpdateProjectsPayload>) {
  try {
    const response: ISuccessResponse<IUpdateProjectsSuccessResponseBody> = yield call(API.updateProjects, action.payload)

    yield put(updateProjectsSuccess(response.data))
  } catch (e) {
    Logger.error(e, 'Projects could not be updated')
    yield put(updateProjectsFailure())
  }
}

function* deleteProjectsSaga(action: IAction<IDeleteProjectsPayload>) {
  try {
    yield call(API.deleteProjects, action.payload)
    yield put(deleteProjectsSuccess({ projectIds: action.payload.projectIds }))

    if (action.payload.notifyAboutSuccess) {
      toastr.success('', 'Project(s) deleted')
    }
  } catch (e) {
    Logger.error(e, 'Project(s) could not be deleted')
    yield put(deleteProjectsFailure())
  }
}

function* createProjectSaga(action: IAction<ICreateProjectPayload>) {
  try {
    const response: ISuccessResponse<ICreateProjectSuccessResponseBody> = yield call(API.createProject, action.payload)
    const projectId = response.data.data[0].id
    const projectVersionId = response.data.data[0].relationships.projectVersions.data[0].id
    yield put(createProjectSuccess())
    toastr.success('', 'Project created')
    window.location.href = `/projects/${projectId}/project_versions/${projectVersionId}`
  } catch (e) {
    Logger.error(e, 'Project could not be created')
    yield put(createProjectFailure())
  }
}

function* updateProjectTitleSaga(action: IAction<IUpdateProjectTitlePayload>) {
  try {
    yield call(API.updateProjectTitle, action.payload)
    yield put(updateProjectTitleSuccess(action.payload))

    toastr.success('', 'Project renamed')
  } catch (e) {
    Logger.error(e, 'Project could not be renamed')
    yield put(updateProjectTitleFailure())
  }
}

function* createClipsSaga(action: IAction<ICreateClipsPayload>): Generator<any, any, any> {
  try {
    yield call(API.createClips, action.payload)
    yield put(createClipsSuccess())
    yield put(completeProjectSubmission())

    toastr.success('', 'Request submitted')
    yield put(closeSetupProjectPopup())
    showConfetti()

    const state = yield select()
    yield put(getUserInfo())

    const searchText = state.projects.searchText
    const payloadFetchProjects = {
      workspaceId: state.workspaces.currentWorkspaceId,
      page: 1,
      selectedLabels: state.labels.selectedLabelIds,
      ...(searchText.length > 0 ? { searchText } : {}),
    }

    yield put(fetchProjects(payloadFetchProjects))
  } catch (e) {
    yield put(createClipsFailure())
    yield put(failProjectSubmission())
    Logger.error(e, 'Request could not be submitted')
  }
}

function* startBulkExportationSaga(action: IAction<IStartBulkExportationPayload>) {
  try {
    yield call(API.startBulkExportation, action.payload)
    yield put(startBulkExportationSuccess())

    toastr.success('', 'Exportation started')
    yield put(closeDashboardPopups())
  } catch (e) {
    Logger.error(e, 'Exportation could not be started')
    yield put(startBulkExportationFailure())
  }
}

function* projectSagas() {
  yield takeEvery(ProjectActionTypes.DELETE_PROJECTS, deleteProjectsSaga)
  yield takeLatest(ProjectActionTypes.FETCH_PROJECTS, fetchProjectsSaga)
  yield takeLatest(ProjectActionTypes.UPDATE_PROJECTS, updateProjectsSaga)
  yield takeLatest(ProjectActionTypes.CREATE_PROJECT, createProjectSaga)
  yield takeLatest(ProjectActionTypes.UPDATE_PROJECT_TITLE, updateProjectTitleSaga)
  yield takeLatest(ProjectActionTypes.CREATE_CLIPS, createClipsSaga)
  yield takeLatest(ProjectActionTypes.START_BULK_EXPORTATION, startBulkExportationSaga)
}

export default projectSagas
